import { HttpInterceptorFn } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, finalize, timeout } from 'rxjs/operators';
import { LoadingIndicatorService } from '#services';

export const LONG_RUNNING_URL_PATTERNS = new InjectionToken<string[]>('LONG_RUNNING_URL_PATTERNS', {
  providedIn: 'root',
  factory: () => ['/import'],
});

export const httpLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingIndicatorService = inject(LoadingIndicatorService);
  const longRunningPatterns = inject(LONG_RUNNING_URL_PATTERNS);

  // Only track API calls
  const isApiCall = req.url.includes('/api');

  if (isApiCall) {
    loadingIndicatorService.incrementRequests();
  }

  const isLongRunning = longRunningPatterns.some(pattern => req.url.includes(pattern));
  const stream$ = next(req);
  const timedStream$ = isLongRunning ? stream$ : stream$.pipe(timeout(30_000));

  return timedStream$.pipe(
    catchError(error => throwError(() => error)),
    finalize(() => {
      if (isApiCall) {
        loadingIndicatorService.decrementRequests();
      }
    })
  );
};
